import React from 'react';

interface NavReminderBadgeProps {
  amount: number;
}

export const NavReminderBadge: React.FC<NavReminderBadgeProps> = ( { amount } ) => {
  if ( amount <= 0 ) {
    return null;
  }

  return (
    <span
      className={ [
        'badge badge-danger position-absolute rounded-circle',
        'd-flex align-items-center justify-content-center starting-bell',
      ].join( ' ' ) }
      style={ {
        top: '14px',
        left: '14px',
        minWidth: '16px',
        height: '16px',
        padding: amount > 99 ? '0 2px' : 0,
        fontSize: amount > 99 ? '7px' : '9px',
        lineHeight: 1,
        boxShadow: '0 0 0 1px #fff',
      } }
    >
      { amount > 99 ? '99+' : amount }
    </span>
  );
};
